/* eslint-disable react/jsx-indent-props */
/* eslint-disable object-curly-newline */
/* eslint-disable quotes */
/* eslint-disable indent */
import React, { useEffect, useRef, useState } from 'react';
import './Email.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getAccountsStart } from 'store/actions';
import SelectDepositMethodModal from 'components/Modals/Deposits/SelectDepositMethodModal';

const Email = () => {
  const iframeRef = useRef(null);
  const dispatch = useDispatch();

  const { accounts } = useSelector((state) => state.forex.accounts);
  const [flag, setFlag] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  // Filter live and demo accounts
  const liveAccounts = accounts?.filter(account => account.accountTypeId.type === 'LIVE');

  // Check for balance >= 100 once accounts are updated
  useEffect(() => {
    if (liveAccounts?.length > 0) {
      const hasEnoughBalance = liveAccounts.some(account => parseFloat(account.Balance) >= 100);
      setFlag(hasEnoughBalance);
    }
  }, [accounts]);
  const sendToIframe = () => {
    const email = accounts[0]?.customerId?.email;
    const account = accounts[0]?.login;
    const server = 'MarketsAct-server';


    if (iframeRef.current) {
      iframeRef.current.contentWindow.postMessage(
        {
          type: 'formData',
          email,
          account,
          server,
        },
        '*'
      );
    }
  };

  useEffect(() => {
    dispatch(getAccountsStart({ type: "LIVE" }));
  }, [dispatch]);

    return (
      <div className="subscribe-page">
    {!flag && (
      <div className="overlay">
        <div className="overlay-content">
          <p>You must have a LIVE account with a balance of at least $100 to access this feature.</p>
          <button onClick={() => setOpenModal(true)}>
            Deposit Now
          </button>
        </div>
      </div>
    )}

  <p className="description">
    <strong>Sign up</strong> to get personalized signals, daily alerts, and news.
    <br />
    <span style={{ color: '#28a745' }}>Your trading, your rules.</span>
  </p>
    <iframe
      ref={iframeRef}
      id="form"
      src="https://dashboard.tradingbull.ai/subscribeemail?language=english&ispublic=false&token=d120b3e5-7929-4aaf-a2b9-7dee98e1998e&c=marketact"
      title="Subscription Form"
    />

    <button disabled={!flag} onClick={sendToIframe}>Send to iframe</button>

      <SelectDepositMethodModal
          isOpen={openModal}
          toggleOpen={() => {
              setOpenModal(!openModal);
            }}
      />
</div>
  );
};

export default Email;